import formatNumberWithCommas from "components/Common/CommaSeparator"
import { downloadBillPaymentExcel, vendorPaymentListExcel } from "helpers/fakebackend_helper"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Modal, Table } from "reactstrap"
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"
import { paymentAmountList, vendorPaymentList } from "store/actions"

const VendorPaymentModal = ({ isOpen, toggle, filterResponse }) => {
  const dispatch = useDispatch()

  const paymentListState = state =>
    state.Dashboard?.vendorPaymentList?.data
  const paymentList = useSelector(paymentListState) || []
  // const paymentList = []

  useEffect(() => {
    if (isOpen === true) {
      dispatch(vendorPaymentList({ filter: filterResponse }))
    }
  }, [filterResponse, dispatch, isOpen])

  const handleExport = async () => {
    // Construct the URL for download
    const value = {
      filter: filterResponse,
      type: "VendorPayment",
    }
    const downloadUrl = await vendorPaymentListExcel(value)
  }

  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Vendor Payment List
        </h5>
        <button
          onClick={handleExport}
          type="button"
          className="btn btn-primary btn-sm me-4"
        >
          Export
        </button>
        <button
          onClick={toggle}
          type="button"
          className="close mt-2"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <SimpleBar style={{ maxHeight: "60vh", overflowX: "auto" }}>
          <div style={{ minWidth: "100%" }}>
            <Table className="table table-striped mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Vendor Name</th>
                  <th>Payment Date</th>
                  <th>Payment no</th>
                  <th>Payment Mode</th>
                  <th>Payment</th>
                  <th>TDS</th>
                </tr>
              </thead>
              <tbody>
                {((paymentList && paymentList) || []).map((row, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{row.vendor_name}</td>
                    <td>{row.payment_date}</td>
                    <td>{row.payment_inv_no}</td>
                    <td>{row.payment_mode}</td>
                    <td>{formatNumberWithCommas(row.amount_paid)}</td>
                    <td>{formatNumberWithCommas(row.total_tds_amount)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  )
}

export default VendorPaymentModal
